"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactHotkeys = require("react-hotkeys");

var _ratio = require("../../../services/ratio/ratio.service");

var _ratio2 = _interopRequireDefault(require("../../shapes/ratio.shape"));

var _slider = _interopRequireDefault(require("../../../slider/slider"));

var _videoControls = require("../video-controls.effect");

var _videoSeekPreview = _interopRequireDefault(require("../video-seek-preview/video-seek-preview"));

var _videoBufferBar = _interopRequireDefault(require("../video-buffer-bar/video-buffer-bar"));

var _playerActionTypes = _interopRequireDefault(require("../player-action-types"));

var _videoStates = _interopRequireDefault(require("../video-states"));

const SLIDER_STEP = 0.0001; // ~the tiniest step, as Material UI slider doesn't allow skipping steps entirely

const VideoProgress = props => {
  const {
    videoTag,
    videoUrl,
    duration,
    ratio,
    resolution,
    onInteraction,
    onShortcutChange,
    hasSeekPreview
  } = props;
  const {
    time,
    status
  } = (0, _videoControls.useVideoStatus)(videoTag);
  const [barRef, setBarRef] = (0, _react.useState)(null);
  const bar = (0, _react.useCallback)(node => {
    if (!barRef) {
      setBarRef(node);
    }
  }, []);
  const [tenSecCalled, setTenSecCalled] = (0, _react.useState)(false);
  const [halfWayCalled, setHalfWayCalled] = (0, _react.useState)(false);
  const [quarterCalled, setQuarterCalled] = (0, _react.useState)(false);
  const [treeQuarterCalled, setTreeQuarterCalled] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const {
      onEnded
    } = props.callbacks;

    if (status === _videoStates.default.ENDED) {
      setTenSecCalled(false);
      setQuarterCalled(false);
      setHalfWayCalled(false);
      setTreeQuarterCalled(false);

      if (onEnded) {
        onEnded();
      }
    }
  }, [status]);
  (0, _react.useEffect)(() => {
    const currentTimePercent = time * 1000 / duration,
          {
      onHalfWay,
      onQuarter,
      onTreeQuarters,
      onTenSec
    } = props.callbacks;

    if (time >= 10 && onTenSec && !tenSecCalled) {
      setTenSecCalled(true);
      onTenSec();
    }

    if (currentTimePercent >= 0.25 && onQuarter && !quarterCalled) {
      setQuarterCalled(true);
      onQuarter();
    }

    if (currentTimePercent >= 0.50 && onHalfWay && !halfWayCalled) {
      setHalfWayCalled(true);
      onHalfWay();
    }

    if (currentTimePercent >= 0.75 && onTreeQuarters && !treeQuarterCalled) {
      setTreeQuarterCalled(true);
      onTreeQuarters();
    }
  }, [time]);
  const [isActive, setActive] = (0, _react.useState)(false);
  const [isPlayWhenSeek, setIsPlayWhenSeek] = (0, _react.useState)(false);
  const [isDragging, setIsDragging] = (0, _react.useState)(false);
  const [seekingToTime, setSeekingToTime] = (0, _react.useState)(time);

  function seek(newTime) {
    videoTag.currentTime = newTime;
    setSeekingToTime(newTime);
    onInteraction();
  }

  function setActiveFalse() {
    setActive(false);
  } // eslint-disable-next-line arrow-body-style


  (0, _react.useEffect)(() => {
    return () => {
      videoTag.removeEventListener('timeupdate', setActiveFalse, {
        once: true
      });
    };
  }, []); // hotKeys

  const keyMap = {
    INCREMENT_VIDEO_TIME: {
      action: 'keypress',
      sequences: ['right', 'l', 'L']
    },
    DECREMENT_VIDEO_TIME: {
      action: 'keypress',
      sequences: ['left', 'j', 'J']
    }
  };
  const handlers = {
    INCREMENT_VIDEO_TIME: event => {
      event.preventDefault();
      videoTag.currentTime += 5;
      onShortcutChange(_playerActionTypes.default.PROGRESS_FORWARD);
      onInteraction(); // this function will show the video buttom menu
    },
    DECREMENT_VIDEO_TIME: event => {
      event.preventDefault();
      videoTag.currentTime -= 5;
      onShortcutChange(_playerActionTypes.default.PROGRESS_BACK);
      onInteraction();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('video-progress', {
      'video-progress--dragging': isDragging
    }),
    ref: bar
  }, /*#__PURE__*/_react.default.createElement(_reactHotkeys.GlobalHotKeys, {
    keyMap: keyMap,
    handlers: handlers
  }), /*#__PURE__*/_react.default.createElement(_videoBufferBar.default, {
    videoTag: videoTag
  }), /*#__PURE__*/_react.default.createElement(_slider.default, {
    min: 0,
    max: duration / 1000,
    step: SLIDER_STEP,
    defaultValue: time,
    value: isActive ? videoTag.currentTime : time,
    onChange: seek,
    onBeforeChange: () => {
      setActive(true);
      setIsDragging(true);
      setIsPlayWhenSeek(!videoTag.paused);
      videoTag.pause();
    },
    onAfterChange: () => {
      setIsDragging(false);
      videoTag.addEventListener('timeupdate', setActiveFalse, {
        once: true
      });
      isPlayWhenSeek && videoTag.play();
    }
  }), hasSeekPreview && barRef && duration && /*#__PURE__*/_react.default.createElement(_videoSeekPreview.default, {
    timeBar: barRef,
    videoUrl: videoUrl,
    ratio: ratio,
    resolution: resolution,
    time: isDragging ? seekingToTime : undefined,
    show: true
  }));
};
/* eslint-disable react/no-unused-prop-types */


VideoProgress.propTypes = {
  videoTag: _propTypes.default.instanceOf(global.Element),
  onShortcutChange: _propTypes.default.func,
  videoUrl: _propTypes.default.string.isRequired,
  duration: _propTypes.default.number,
  ratio: _ratio2.default,
  resolution: _propTypes.default.number,
  callbacks: _propTypes.default.shape({
    onInit: _propTypes.default.func,
    onHalfWay: _propTypes.default.func,
    onQuarter: _propTypes.default.func,
    onTreeQuarters: _propTypes.default.func,
    onTenSec: _propTypes.default.func,
    onEnded: _propTypes.default.func
  }),
  onInteraction: _propTypes.default.func.isRequired,
  hasSeekPreview: _propTypes.default.bool
};
/* eslint-enable react/forbid-prop-types */

VideoProgress.defaultProps = {
  videoTag: null,
  callbacks: {},
  ratio: _ratio.RATIOS_BY_NAME.wide.key,
  resolution: _ratio.RATIOS_BY_NAME.wide.height,
  duration: undefined,
  onShortcutChange: () => {},
  hasSeekPreview: true
};
var _default = VideoProgress;
exports.default = _default;